import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade lg-size",
  id: "addPhaseModal",
  tabindex: "-1",
  "aria-labelledby": "addModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_6 = {
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = {
  key: 1,
  class: "modal-header"
}
const _hoisted_9 = {
  key: 0,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_10 = {
  key: 1,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_11 = {
  key: 2,
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_13 = { class: "modal-body" }
const _hoisted_14 = {
  key: 0,
  class: "form-group"
}
const _hoisted_15 = { class: "project-budget-block" }
const _hoisted_16 = { class: "project-info-budget" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" }, null, -1)
const _hoisted_21 = { class: "project-info-budget date-wrap d-flex" }
const _hoisted_22 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar" }, null, -1)
const _hoisted_24 = {
  key: 1,
  for: "exampleInputEmail1"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar" }, null, -1)
const _hoisted_26 = { title: "Start Date" }
const _hoisted_27 = /*#__PURE__*/_createVNode("li", null, "-", -1)
const _hoisted_28 = { title: "End Date" }
const _hoisted_29 = { class: "form-wrap pt-0" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_32 = {
  key: 1,
  for: "exampleInputEmail1"
}
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { for: "exampleInputEmail1" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { for: "exampleInputEmail1 to-upper" }
const _hoisted_39 = { value: "3" }
const _hoisted_40 = { value: "2" }
const _hoisted_41 = { value: "1" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = {
  key: 0,
  class: "col-md-6 px-2"
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = { for: "exampleInputEmail1" }
const _hoisted_46 = {
  key: 1,
  class: "col-md-6 px-2"
}
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = { for: "exampleInputEmail1" }
const _hoisted_49 = { for: "vehicle1" }
const _hoisted_50 = { class: "form-group bg-light p-3" }
const _hoisted_51 = {
  key: 0,
  for: "exampleInputEmail1"
}
const _hoisted_52 = { class: "row mx-n2" }
const _hoisted_53 = { class: "col-md-6 px-2" }
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = { for: "" }
const _hoisted_56 = { class: "col-md-6 px-2" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = { for: "exampleInputEmail1" }
const _hoisted_59 = { class: "col-md-12 px-2" }
const _hoisted_60 = { class: "form-group" }
const _hoisted_61 = { for: "exampleInputEmail1" }
const _hoisted_62 = { class: "col-md-12 px-2" }
const _hoisted_63 = { class: "form-group" }
const _hoisted_64 = { for: "exampleInputEmail1" }
const _hoisted_65 = { class: "input-btn" }
const _hoisted_66 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_67 = {
  key: 0,
  class: "table-add-phase"
}
const _hoisted_68 = { class: "table table-bordered table-limit-input" }
const _hoisted_69 = {
  key: 0,
  scope: "col",
  title: "Contractor"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("th", {
  scope: "col",
  title: "employee member"
}, "EMPL", -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Name", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "Email", -1)
const _hoisted_73 = /*#__PURE__*/_createVNode("th", {
  scope: "col",
  title: "hourly rate"
}, "H.R.", -1)
const _hoisted_74 = /*#__PURE__*/_createVNode("th", { scope: "col" }, null, -1)
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times-circle" }, null, -1)
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = { for: "" }
const _hoisted_79 = {
  key: 0,
  class: "image-in-chat preview-image-list"
}
const _hoisted_80 = { class: "row mx-n2" }
const _hoisted_81 = {
  key: 0,
  class: "shadowed-card bg-white mb-2 mr-2"
}
const _hoisted_82 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_83 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_84 = { class: "sr-only" }
const _hoisted_85 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_86 = { class: "imaged-col" }
const _hoisted_87 = { class: "small-img-wrap" }
const _hoisted_88 = { class: "size" }
const _hoisted_89 = {
  key: 1,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_90 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_91 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_92 = { class: "sr-only" }
const _hoisted_93 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_94 = { class: "imaged-col" }
const _hoisted_95 = { class: "small-img-wrap" }
const _hoisted_96 = { class: "size" }
const _hoisted_97 = {
  key: 2,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_98 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_99 = {
  class: "spinner-border",
  role: "status"
}
const _hoisted_100 = { class: "sr-only" }
const _hoisted_101 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_102 = { class: "imaged-col" }
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_104 = { class: "size" }
const _hoisted_105 = {
  key: 3,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_106 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_107 = { class: "centered-wrap" }
const _hoisted_108 = {
  class: "spinner-border big-spinner",
  role: "status"
}
const _hoisted_109 = { class: "sr-only" }
const _hoisted_110 = { class: "size" }
const _hoisted_111 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_112 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_DebouncedCurrencyInput = _resolveComponent("DebouncedCurrencyInput")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_DragAndDropZone = _resolveComponent("DragAndDropZone")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.editMode && _ctx.editFrom==='phase')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('edit_phase')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideAddPhaseModal && _ctx.hideAddPhaseModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_7
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_8, [
                (_ctx.editFrom ==='createPhase')
                  ? (_openBlock(), _createBlock("h5", _hoisted_9, _toDisplayString(_ctx.$t('add_phase')), 1))
                  : (_ctx.editMode && _ctx.editFrom==='task')
                    ? (_openBlock(), _createBlock("h5", _hoisted_10, _toDisplayString(_ctx.$t('edit_task')), 1))
                    : (_openBlock(), _createBlock("h5", _hoisted_11, _toDisplayString(_ctx.$t('add_task')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideAddPhaseModal && _ctx.hideAddPhaseModal(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_12
                ])
              ])),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_ErrorList, {
              errors: _ctx.state.ui.error.errorList.createPhase,
              hasError: _ctx.state.ui.error.hasError
            }, null, 8, ["errors", "hasError"]),
            (
              _ctx.projectAcknowledgementDetail)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      (!_ctx.phase || _ctx.editFrom==='phase' ||_ctx.editFrom ==='createPhase')
                        ? (_openBlock(), _createBlock("h3", _hoisted_17, [
                            _hoisted_18,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('project_name')) + "- " + _toDisplayString(_ctx.projectDetail?.name), 1)
                          ]))
                        : (_openBlock(), _createBlock("h3", _hoisted_19, [
                            _hoisted_20,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('phase_name')) + "- " + _toDisplayString(_ctx.phase?.name), 1)
                          ]))
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode("ul", null, [
                        (_ctx.modelName == 'phase' || _ctx.editFrom==='phase')
                          ? (_openBlock(), _createBlock("li", _hoisted_22, [
                              _hoisted_23,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('project_date')), 1)
                            ]))
                          : (_openBlock(), _createBlock("li", _hoisted_24, [
                              _hoisted_25,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('phase_date')), 1)
                            ])),
                        _createVNode("li", _hoisted_26, _toDisplayString(_ctx.projectAcknowledgementDetail.start_date.slice(0, 10)), 1),
                        _hoisted_27,
                        _createVNode("li", _hoisted_28, _toDisplayString(_ctx.projectAcknowledgementDetail.end_date.slice(0, 10)), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                (!_ctx.editMode && !_ctx.phase)
                  ? (_openBlock(), _createBlock("label", _hoisted_31, _toDisplayString(_ctx.$t('name')), 1))
                  : (_openBlock(), _createBlock("label", _hoisted_32, _toDisplayString(_ctx.$t('name')), 1)),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.phase.name = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.phase.name]
                ])
              ]),
              _createVNode("div", _hoisted_33, [
                _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('description')), 1),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.phase.description = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.phase.description]
                ])
              ]),
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('priority')), 1),
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.phase.priority = $event))
                    }, [
                      _createVNode("option", _hoisted_39, _toDisplayString(_ctx.$t('high')), 1),
                      _createVNode("option", _hoisted_40, _toDisplayString(_ctx.$t('medium')), 1),
                      _createVNode("option", _hoisted_41, _toDisplayString(_ctx.$t('low')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.state.data.phase.priority]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_42, [
                  (!_ctx.editMode && !_ctx.phase)
                    ? (_openBlock(), _createBlock("div", _hoisted_43, [
                        _createVNode("div", _hoisted_44, [
                          _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('estimated_budget')), 1),
                          _createVNode(_component_DebouncedCurrencyInput, {
                            class: "form-control",
                            modelValue: _ctx.state.data.phase.estBudget,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.phase.estBudget = $event)),
                            options: {
                        currency: 'USD',
                        hideCurrencySymbolOnFocus: false,
                        hideGroupingSeparatorOnFocus: false,
                        hideNegligibleDecimalDigitsOnFocus: false,
                      }
                          }, null, 8, ["modelValue"])
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_46, [
                        _createVNode("div", _hoisted_47, [
                          _createVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('estimate_budget')), 1),
                          _withDirectives(_createVNode("input", {
                            class: "ml-3 mr-2",
                            type: "checkbox",
                            id: "vehicle1",
                            name: "vehicle1",
                            value: "Bike",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.phase.checkPercentage = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.state.data.phase.checkPercentage]
                          ]),
                          _createVNode("label", _hoisted_49, _toDisplayString(_ctx.$t('percentage')), 1)
                        ]),
                        _createVNode("div", _hoisted_50, [
                          (_ctx.state.data.phase.checkPercentage)
                            ? (_openBlock(), _createBlock("label", _hoisted_51, _toDisplayString(_ctx.$t('enter_percentage')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.data.phase.checkPercentage)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 1,
                                type: "number",
                                class: "form-control mb-2",
                                id: "exampleInputEmail1",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.phase.percentage = $event)),
                                min: "1",
                                max: "100"
                              }, null, 512)), [
                                [_vModelText, _ctx.state.data.phase.percentage]
                              ])
                            : _withDirectives((_openBlock(), _createBlock("input", {
                                key: 2,
                                type: "number",
                                class: "form-control",
                                id: "exampleInputEmail1",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.phase.estBudget = $event)),
                                min: "1"
                              }, null, 512)), [
                                [_vModelText, _ctx.state.data.phase.estBudget]
                              ]),
                          (_ctx.state.data.phase.checkPercentage)
                            ? _withDirectives((_openBlock(), _createBlock("input", {
                                key: 3,
                                disabled: 
                        _ctx.state.data.phase.checkPercentage ? true : false
                      ,
                                type: "number",
                                class: "form-control",
                                id: "exampleInputEmail1",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.dispatchedAmount = $event)),
                                min: "1"
                              }, null, 8, ["disabled"])), [
                                [_vModelText, _ctx.dispatchedAmount]
                              ])
                            : _createCommentVNode("", true)
                        ])
                      ]))
                ])
              ]),
              _createVNode("div", _hoisted_52, [
                _createVNode("div", _hoisted_53, [
                  _createVNode("div", _hoisted_54, [
                    _createVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('start_date')), 1),
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.phase.startDate,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.data.phase.startDate = $event)),
                      "min-date": _ctx.state.data.minDate,
                      "max-date": _ctx.state.data.maxDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents)), null, 16, ["value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date"])
                  ])
                ]),
                _createVNode("div", _hoisted_56, [
                  _createVNode("div", _hoisted_57, [
                    _createVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('end_date')), 1),
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.phase.endDate,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.data.phase.endDate = $event)),
                      "min-date": _ctx.state.data.endDateMindate,
                      "max-date": _ctx.state.data.maxDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents), {
                          disabled: _ctx.state.ui.isLoading.enableEndDate
                        }), null, 16, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date"])
                  ])
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _createVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('add_existing_member')), 1),
                    _withDirectives(_createVNode("select", {
                      disabled: 
                      _ctx.state.data.existingMembers.members &&
                      _ctx.state.data.existingMembers.members.length === 0
                    ,
                      class: "form-control mb-2",
                      id: "user.id",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.data.phase.existedMembers = $event)),
                      onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                    }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.existingMembers
                        .members, (item, itemIndex) => {
                        return (_openBlock(), _createBlock("option", {
                          value: item.email,
                          key: itemIndex
                        }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                      }), 128))
                    ], 40, ["disabled"]), [
                      [_vModelSelect, _ctx.state.data.phase.existedMembers]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_62, [
                  _createVNode("div", _hoisted_63, [
                    _createVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('add_new_member')), 1),
                    _createVNode("div", _hoisted_65, [
                      _withDirectives(_createVNode("input", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.state.data.invite.newUsers = $event)),
                        type: "email",
                        class: "form-control",
                        id: "exampleInputEmail1",
                        "aria-describedby": "emailHelp",
                        placeholder: "Type email and press enter or click add button",
                        onKeydown: _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.state.data.invite.newUsers]
                      ]),
                      _createVNode("button", {
                        onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.changeInviteMember && _ctx.changeInviteMember(...args)))
                      }, [
                        _hoisted_66
                      ])
                    ])
                  ])
                ])
              ]),
              (
                _ctx.state.data.invite.invites && _ctx.state.data.invite.invites.length
              )
                ? (_openBlock(), _createBlock("div", _hoisted_67, [
                    _createVNode("table", _hoisted_68, [
                      _createVNode("thead", null, [
                        _createVNode("tr", null, [
                          (!_ctx.phase)
                            ? (_openBlock(), _createBlock("th", _hoisted_69, "CONTR"))
                            : _createCommentVNode("", true),
                          _hoisted_70,
                          _hoisted_71,
                          _hoisted_72,
                          _hoisted_73,
                          _hoisted_74
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: inviteIndex }, [
                            (!_ctx.phase)
                              ? (_openBlock(), _createBlock("td", _hoisted_75, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input ml-0",
                                    type: "checkbox",
                                    value: "",
                                    "onUpdate:modelValue": ($event: any) => (invite.sub_contractor = $event),
                                    onChange: ($event: any) => (_ctx.contractorChange(invite)),
                                    "aria-label": "Checkbox for following text input"
                                  }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                    [_vModelCheckbox, invite.sub_contractor]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                class: "form-check-input ml-0",
                                type: "checkbox",
                                value: "",
                                "aria-label": "Checkbox for following text input",
                                "onUpdate:modelValue": ($event: any) => (invite.member = $event),
                                onChange: ($event: any) => (_ctx.memberChange(invite))
                              }, null, 40, ["onUpdate:modelValue", "onChange"]), [
                                [_vModelCheckbox, invite.member]
                              ])
                            ]),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                id: "nameMember",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": ($event: any) => (invite.name = $event)
                              }, null, 8, ["onUpdate:modelValue"]), [
                                [_vModelText, invite.name]
                              ])
                            ]),
                            _createVNode("td", null, _toDisplayString(invite.email), 1),
                            _createVNode("td", null, [
                              _withDirectives(_createVNode("input", {
                                class: invite.error ? 'hour-limit-input input-warning' : 'hour-limit-input',
                                type: "number",
                                id: "hourlyForMember",
                                "aria-describedby": "emailHelp",
                                "onUpdate:modelValue": ($event: any) => (invite.hourly = $event)
                              }, null, 10, ["onUpdate:modelValue"]), [
                                [_vModelText, invite.hourly]
                              ])
                            ]),
                            _createVNode("td", null, [
                              _createVNode("a", {
                                class: "text-danger",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                              }, [
                                _hoisted_76
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_77, [
                _createVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('upload_attachment')), 1),
                _createVNode(_component_DragAndDropZone, {
                  onDrop: _withModifiers(_ctx.dropFiles, ["prevent"]),
                  onDropFiles: _ctx.dropFiles
                }, null, 8, ["onDrop", "onDropFiles"]),
                (
                  _ctx.state.data.imagesToUpload &&
                  _ctx.state.data.imagesToUpload.length
                )
                  ? (_openBlock(), _createBlock("div", _hoisted_79, [
                      _createVNode("div", _hoisted_80, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.imagesToUpload, (image, imageIndex) => {
                          return (_openBlock(), _createBlock("div", { key: imageIndex }, [
                            (
                        image.extension === 'jpg' ||
                        image.extension === 'png' ||
                        image.extension === 'jpeg' ||
                        image.extension === 'gif'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_81, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_82, [
                                        _createVNode("span", _hoisted_83, [
                                          _createVNode("span", _hoisted_84, _toDisplayString(_ctx.$t('loading1')), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_85
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_86, [
                                    _createVNode("div", _hoisted_87, [
                                      _createVNode("img", {
                                        src: image.file,
                                        alt: "",
                                        height: "200"
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image?.name), 1),
                                    _createVNode("p", _hoisted_88, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (image.extension === 'pdf')
                              ? (_openBlock(), _createBlock("div", _hoisted_89, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_90, [
                                        _createVNode("span", _hoisted_91, [
                                          _createVNode("span", _hoisted_92, _toDisplayString(_ctx.$t('loading1')), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_93
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_94, [
                                    _createVNode("div", _hoisted_95, [
                                      _createVNode("img", {
                                        src: 
                              _ctx.state.data.imageBaseUrl
                                ? `${_ctx.state.data.imageBaseUrl}img/pdf.jpg`
                                : 'img/pdf.jpg'
                            ,
                                        alt: ""
                                      }, null, 8, ["src"])
                                    ]),
                                    _createVNode("h5", null, _toDisplayString(image?.name), 1),
                                    _createVNode("p", _hoisted_96, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                        image.extension === 'doc' ||
                        image.extension === 'docx'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_97, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_98, [
                                        _createVNode("span", _hoisted_99, [
                                          _createVNode("span", _hoisted_100, _toDisplayString(_ctx.$t('loading1')), 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_101
                                  ], 8, ["onClick"]),
                                  _createVNode("div", _hoisted_102, [
                                    _hoisted_103,
                                    _createVNode("h5", null, _toDisplayString(image.name), 1),
                                    _createVNode("p", _hoisted_104, _toDisplayString(image.size), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (
                        image.extension === 'mp4' ||
                        image.extension === 'mov' ||
                        image.extension === 'MOV' ||
                        image.extension === 'wmv' ||
                        image.extension === 'webm' ||
                        image.extension === 'ogg' ||
                        image.extension === 'avi' ||
                        image.extension === 'x-ms-wmv'
                      )
                              ? (_openBlock(), _createBlock("div", _hoisted_105, [
                                  (image.isuploded)
                                    ? (_openBlock(), _createBlock("div", _hoisted_106, [
                                        _createVNode("div", _hoisted_107, [
                                          _createVNode("span", _hoisted_108, [
                                            _createVNode("span", _hoisted_109, _toDisplayString(_ctx.$t('loading1')), 1)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode("img", {
                                    src: 
                          _ctx.state.data.imageBaseUrl
                            ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                            : 'img/video-icon.png'
                        ,
                                    alt: "",
                                    height: "200"
                                  }, null, 8, ["src"]),
                                  _createVNode("h5", null, _toDisplayString(image.name), 1),
                                  _createVNode("p", _hoisted_110, _toDisplayString(image.size), 1),
                                  _createVNode("a", {
                                    class: "remove-btnn",
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                                  }, [
                                    _hoisted_111
                                  ], 8, ["onClick"])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_112, [
            _createVNode(_component_Button, {
              buttonName: _ctx.state.data.buttonName,
              buttonLoading: _ctx.state.ui.isPostLoading.createPhase,
              onButtonTrigger: _ctx.update
            }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger"]),
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.hideAddPhaseModal && _ctx.hideAddPhaseModal(...args)))
            }, _toDisplayString(_ctx.$t('close')), 1)
          ])
        ])
      ])
    ])
  ]))
}